import { Component, Input } from '@angular/core';



@Component({
  selector: 'app-sub-page',
  templateUrl: './sub-page.component.html',
  styleUrls: ['./sub-page.component.scss'],
  host: {
    'class': 'd-flex flex-column flex-nowrap flex-grow-0 flex-shrink-0 w-100 h-100 pt-2'
  }
})
export class SubPageComponent {
  @Input() icon: string;
  @Input() title: string;
  @Input() titleSuffix: string;
  @Input() homeLink: string | Array<any>;
}
